import React, { Component, ReactElement } from 'react';

import { arrayOf, bool, element, node, oneOf, oneOfType, string } from 'prop-types';

import { enumValues } from '@philips-emr/tws-utils';

import ComponentType from '../component-type';

import ContainerProvider from './container-provider';

const excludeProperties = ['acceptedTypes', 'exclusive'];

class Container extends Component {
  static propTypes = {
    acceptedTypes: arrayOf(oneOf(enumValues(ComponentType))),
    children: oneOfType([element, arrayOf(element), node, arrayOf(node)]),
    className: string,
    tag: string,
    uuid: string,
    repeated: bool,
  };

  static defaultProps = {
    className: '',
    tag: 'div',
  };

  getProps(properties: Record<string, any>): Record<string, any> {
    return Object.keys(properties)
      .filter(key => !excludeProperties.includes(key))
      .reduce((props: Record<string, any>, key) => (props[key] = properties[key], props), {});
  }

  render(): ReactElement {
    const { children, className, tag: Tag, ...otherProps } = this.getProps(this.props);

    return (
      <Tag className={`c-container ${className}`} {...otherProps}>
        {children}
      </Tag>
    );
  }
}

ContainerProvider.register(Container, () => true);

export default Container;
